import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
// EvaluationProvider kept for future use — evaluation page is hidden, not deleted
// import { EvaluationProvider } from './context/EvaluationContext';
import { PortfolioProvider } from './context/PortfolioContext';
import { ClientProvider } from './context/ClientContext';
import { DocumentProvider } from './context/DocumentContext';
import { ActionProvider } from './context/ActionContext';
import { AgentProvider } from './context/AgentContext';
import AgentWidget from './components/AgentWidget/AgentWidget';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/layout/AppLayout';
import ErrorBoundary from './components/ErrorBoundary';
import PageSkeleton from './components/PageSkeleton';
import ScrollToTop from './components/ScrollToTop';
import { GlassFilter } from './components/ui/liquid-glass';
import './index.css';

const LandingPage = lazy(() => import('./pages/LandingPage/LandingPage'));
const AdvisorDashboard = lazy(() => import('./pages/AdvisorDashboard/AdvisorDashboard'));
const DashboardPage = lazy(() => import('./pages/DashboardPage/DashboardPage'));
const PortfolioDetailPage = lazy(() => import('./pages/PortfolioDetailPage/PortfolioDetailPage'));
const TryVasariPage = lazy(() => import('./pages/TryVasariPage'));
const PricingPage = lazy(() => import('./pages/PricingPage/PricingPage'));
const LoginPage = lazy(() => import('./pages/LoginPage/LoginPage'));
const SignupPage = lazy(() => import('./pages/SignupPage/SignupPage'));
const ClientsPage = lazy(() => import('./pages/ClientsPage/ClientsPage'));
const ClientDetailPage = lazy(() => import('./pages/ClientDetailPage/ClientDetailPage'));
const DocumentsPage = lazy(() => import('./pages/DocumentsPage/DocumentsPage'));
const ClientDocumentsPage = lazy(() => import('./pages/DocumentsPage/ClientDocumentsPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage/SettingsPage'));

function App() {
  return (
    <BrowserRouter>
      {/* SVG filter definition — used by GlassLayers via filter: url(#glass-distortion) */}
      <GlassFilter />
      <AuthProvider>
        <ThemeProvider>
        <ScrollToTop />
          <PortfolioProvider>
            <ClientProvider>
            <DocumentProvider>
            <ActionProvider>
            <AgentProvider>
            <ErrorBoundary><AgentWidget /></ErrorBoundary>
            <ErrorBoundary>
              <Suspense fallback={<PageSkeleton />}>
                <Routes>
                  {/* Public routes */}
                  <Route path="/" element={
                    <ErrorBoundary><LandingPage /></ErrorBoundary>
                  } />
                  <Route path="/contact" element={
                    <ErrorBoundary><TryVasariPage /></ErrorBoundary>
                  } />
                  <Route path="/pricing" element={
                    <ErrorBoundary><PricingPage /></ErrorBoundary>
                  } />
                  <Route path="/login" element={
                    <ErrorBoundary><LoginPage /></ErrorBoundary>
                  } />
                  <Route path="/signup" element={
                    <ErrorBoundary><SignupPage /></ErrorBoundary>
                  } />

                  {/* Protected routes — rendered inside the sidebar layout */}
                  <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                    <Route path="/dashboard" element={<ErrorBoundary><AdvisorDashboard /></ErrorBoundary>} />
                    <Route path="/portfolio" element={<ErrorBoundary><DashboardPage /></ErrorBoundary>} />
                    <Route path="/portfolio/:id" element={<ErrorBoundary><PortfolioDetailPage /></ErrorBoundary>} />
                    <Route path="/clients" element={<ErrorBoundary><ClientsPage /></ErrorBoundary>} />
                    <Route path="/clients/:id" element={<ErrorBoundary><ClientDetailPage /></ErrorBoundary>} />
                    <Route path="/documents" element={<ErrorBoundary><DocumentsPage /></ErrorBoundary>} />
                    <Route path="/documents/:clientId" element={<ErrorBoundary><ClientDocumentsPage /></ErrorBoundary>} />
                    <Route path="/settings" element={<ErrorBoundary><SettingsPage /></ErrorBoundary>} />
                  </Route>
                </Routes>
              </Suspense>
            </ErrorBoundary>
            </AgentProvider>
            </ActionProvider>
            </DocumentProvider>
            </ClientProvider>
          </PortfolioProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
